module.exports = __webpack_public_path__ + "assets/images/project/jem/mobile.svg?v=1fa6549f";